import React, { createContext, useContext } from 'react';

interface SubscriptionContextType {
  hasFeature: (feature: string) => boolean;
  showUpgradePrompt: (feature: string) => void;
}

const SubscriptionContext = createContext<SubscriptionContextType>({
  hasFeature: () => true, // Always return true to enable all features
  showUpgradePrompt: () => {} // No-op function since we're not showing prompts
});

export function SubscriptionProvider({ children }: { children: React.ReactNode }) {
  const hasFeature = () => true; // Always return true
  const showUpgradePrompt = () => {}; // No-op function

  return (
    <SubscriptionContext.Provider value={{ hasFeature, showUpgradePrompt }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
}